
import Vue from 'vue'
import UiIcon from '@/components/common/UiIcon.vue'
import {Action, Getter, namespace} from 'vuex-class'
import {Component} from 'vue-property-decorator'
import {validationMixin} from 'vuelidate'
import {required, numeric} from 'vuelidate/lib/validators'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  components: {UiIcon},
  mixins: [validationMixin],
  validations: {
    form: {
      prospectId: {
        required,
        numeric
      }
    }
  }
})
export default class Header extends Vue {
  @uiModule.Getter('isLoadingGetter') isLoading: any
  @authModule.Getter('meGetter') me: any
  @authModule.Action('logoutAction') logout: any

  menuOpen = false

  form = {
    prospectId: null
  }

  get fullName() {
    if (!this.me) return ''
    return [this.me.PRENOM, this.me.NOM].filter(Boolean).join(' ') || this.me.NOM_UTILISATEUR
  }

  get initials() {
    return this.fullName
      .split(' ')
      .map((part) => part.charAt(0))
      .slice(0, 2)
      .join('')
      .toUpperCase()
  }

  updateConseillerInfo() {
    this.$router.push({name: 'ChangeConseillerInfo'})
  }

  updatePassword() {
    this.$router.push({name: 'ChangePassword'})
  }

  goToProspectHandler() {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      this.$router.push({name: 'prospectDetail', params: {id: this.form.prospectId}})
      this.$v.$reset()
      this.form.prospectId = null
    } else {
      window.scrollTo(0, 0)
    }
  }
}
